import React, { useState, useRef, useEffect } from 'react';
import {
  Card, Grid, Tab, Tabs, Link, Paper,
  TableHead, IconButton, MenuItem, Button, Popover,
  Stack, Table, TableBody, TableCell, TableContainer,
  TextField, Autocomplete, Typography,
  CardContent
} from '@mui/material'
import { DataGrid, useGridApiRef, GridEditInputCell, useGridApiContext } from '@mui/x-data-grid';
import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import ReactApexChart from "react-apexcharts";
import { Box } from '@mui/system';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import YearlyDashboard from './YearlyDashboard';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { ADD_ANNUALPLANT, authKey, CALCULATE_ANNUAL_DASHBOARD, GET_All_DISTRICT, GET_All_STATE, GET_ANNUALDEMAND, GET_DEMAND_HOLIDAY, GET_EXPECTED_DELIVERY_SHORTFALL, GET_RBCBRATIO, GET_SUGGESTEDRBCBRATIO, SAVE_EXPECTED_DELIVERY_SHORTFALL, SAVE_HOLIDAY, SAVE_RBCBRATIO } from '../../common/URLs';
import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { CustomButton } from '../../common/custom-button/customButton';
import moment from 'moment';
import { API_DATE_FORMAT, BASIC_DATE_FORMAT, PROD } from '../../common/constants';
import { async } from 'q';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from "../../common/commonValidations";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { handleNumberFieldFocus } from '../../common/commonFunction';
import { CalculateIcon, EditIcon, SubmitIcon, ViewIcon } from '../../common/icons';
import apiClient from '../../axios';

const _ = require('lodash');

// ----------------------------------------------------------------------


function YearlyInput() {
  const apiRef = useGridApiRef();
  let expectedDeliveryShortfallUpdatedData = {}
  let tempArr = []
  const uuid = localStorage.getItem('uuid');
  const [hitSelectedDates, setHitSelectedDates] = useState();
  const [lleSelectedDates, setLleSelectedDates] = useState();
  const [transporterSelectedDates, setTransporterSelectedDates] = useState();
  const [plantSelectedDates, setPlantSelectedDates] = useState();

  const [hitSelectedDatesApi, setHitSelectedDatesApi] = useState([]);
  const [lleSelectedDatesApi, setLleSelectedDatesApi] = useState([]);
  const [transporterSelectedDatesApi, setTransporterSelectedDatesApi] = useState([]);
  const [plantSelectedDatesApi, setPlantSelectedDatesApi] = useState([]);

  const [isEditBtnDisabled, setIsEditBtnDisabled] = useState(true);
  const [editBtnTitle, setEditBtnTitle] = useState('Edit');

  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [tabValue, setTabValue] = React.useState('1');
  const [showYearlyInputFieldSection, setShowYearlyInputFieldSection] = useState(false);
  const [showYearlyInputGraph, setShowYearlyInputGraph] = useState(true);
  const [annualDemandCB, setAnnualDemandCB] = useState();
  const [financialYearError, setFinancialYearError] = useState('');
  const [suggestedRbCbRatio, setSuggestedRbCbRatio] = useState();
  const [rbCbRatio, setRbCbRatio] = useState();

  const [shortFallMonthLabel, setShortFallMonthLabel] = useState(["APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC", "JAN", "FEB", "MAR"]);
  const [holidayGridData, setHolidayGridData] = useState([]);
  const [shortFallChartData, setShortFallChartData] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [stateValue, setSaStateValue] = useState('');
  const [districtValue, setDistrictValue] = useState('');

  const [cbDemandDialog, setCbDemandDialog] = useState(false);
  const handleCbDemandDialogOpen = () => setCbDemandDialog(true);
  const handleCbDemandDialogClose = () => setCbDemandDialog(false);
  const [rbCbRatioDialog, setRbCbRatioDialog] = useState(false);
  const handleRbCbRatioDialogOpen = () => setRbCbRatioDialog(true);
  const handleRbCbRatioDialogClose = () => setRbCbRatioDialog(false);
  const [expectedAvailabilityInRbDialog, setExpectedAvailabilityInRbDialog] = useState(false);
  const handleExpectedAvailabilityInRbDialogOpen = () => setExpectedAvailabilityInRbDialog(true);
  const handleExpectedAvailabilityInRbDialogClose = () => setExpectedAvailabilityInRbDialog(false);
  const [plantHolidayDialog, setPlantHolidayDialog] = useState(false);
  const handlePlantHolidayDialogOpen = () => setPlantHolidayDialog(true);
  const handlePlantHolidayDialogClose = () => setPlantHolidayDialog(false);
  const [stakeholderHolidayDialog, setStakeholderHolidayDialog] = useState(false);
  const handleStakeholderHolidayDialogOpen = () => setStakeholderHolidayDialog(true);
  const handleStakeholderHolidayDialogClose = () => setStakeholderHolidayDialog(false);
  const [calculateDashboardDialog, setCalculateDashboardDialog] = useState(false);
  const handleCalculateDashboardDialogOpen = () => setCalculateDashboardDialog(true);
  const handleCalculateDashboardDialogClose = () => setCalculateDashboardDialog(false);

  const StyledBox = styled(Box)(({ theme }) => ({
    height: "inherit",
    width: '100%',
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: 'rgb(255,215,115, 0.19)',
      color: '#1a3e72',
      '& .MuiInputBase-root': {
        height: '100%',
      },
    },
    '& .Mui-error': {
      backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
      color: theme.palette.error.main,
    },
  }));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const requestLastWeek = {
    options: {
      title: {
        text: 'Expected Availability (in RB)',
        align: 'center'
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        onItemClick: {
          toggleDataSeries: true
        },
      },
      dataLabels: {
        enabled: false
      },
      labels: ["APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC", "JAN", "FEB", "MAR"],
      chart: {
        type: 'bar',
      },
      xaxis: {
        title: {
          text: ''
        },
      },
      yaxis: {
        title: {
          text: 'Quantity (in MT)',
        },
      },
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
          borderRadius: 4,
        },
      }
    },
    series: [
      { name: "Availability", data: shortFallChartData ? shortFallChartData : [] },
    ]
  };

  const [rowData1, setRowData1] = useState(
    [{
      'id': 1, 'Apr': 0, 'May': 0, 'Jun': 0, 'Jul': 0,
      'Aug': 0, 'Sep': 0, 'Oct': 0, 'Nov': 0, 'Dec': 0,
      'Jan': 0, 'Feb': 0, 'Mar': 0
    }]);

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  }));

    function EditInputCell(props) {
          const { error, id, value: valueProp, field } = props;
          const [value, setValue] = useState(valueProp);
          const apiRef = useGridApiContext();
  
          const handleChange = (event) => {
              const newValue = event.target.value; 
              apiRef.current.setEditCellValue({ id, field, value: newValue });
              setValue(newValue);
          };
  
          useEffect(() => {
              setValue(valueProp);
          }, [valueProp]);
          
          return (
              <StyledTooltip open={!!error} title={error}>
                  <GridEditInputCell {...props} value={value} onChange={handleChange} />
             </StyledTooltip>
          );
      }

  function renderEdit(params) {
    return <EditInputCell {...params} />;
  }

  const [columnDefs] = useState([
    {
      headerName: 'APR', field: 'Apr', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'MAY', field: 'May', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'JUN', field: 'Jun', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'JUL', field: 'Jul', type: 'number', 
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'AUG', field: 'Aug', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'SEP', field: 'Sep', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'OCT', field: 'Oct', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'NOV', field: 'Nov', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'DEC', field: 'Dec', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'JAN', field: 'Jan', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'FEB', field: 'Feb', type: 'number', 
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      headerName: 'MAR', field: 'Mar', type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
  ])

  function getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('en-US', {
      month: 'short',
    });
  }
  const [previewHolidayColDef] = useState([
    {
      field: 'month',
      headerName: 'Month',
      minWidth: 100,
      valueGetter: (params) => {
        if (params.row.month) {
          return getMonthName(params.row.month)
        } else return '-'
      }
    },
    {
      field: 'nonOperatingDaysHit',
      headerName: 'Stakeholder',
      headerClassName: 'super-app-theme--header',
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Tooltip title={params.value.join(" , ")} arrow>
            <Button variant="text" endIcon={<VisibilityIcon />}>
              {params.value.length}
            </Button>
          </Tooltip>

        )
      }
    },
    {
      field: 'nonOperatingDaysPlant',
      headerName: 'Plant',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Tooltip title={params.value.join(" , ")} arrow>
            <Button variant="text" endIcon={<VisibilityIcon />}>
              {params.value.length}
            </Button>
          </Tooltip>

        )
      }
    },
  ])
  const StateDistrictSection = () => {
    return (
      <Stack direction='row' spacing={1}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={stateList ? stateList : []}
          sx={{ width: '100%' }}
          size='small'
          value={stateValue}
          onChange={(e, newInputValue) => onStateChangeHandle(e, newInputValue)}
          renderInput={(params) => <TextField {...params} label="State" />}
        />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={districtList ? districtList : []}
          size='small'
          sx={{ width: '100%' }}
          value={districtValue}
          onChange={(e, newInputValue) => onDistrictChangeHandle(e, newInputValue)}
          renderInput={(params) => <TextField {...params} label="District" />}
        />
      </Stack>
    )

  }
  const YearlyInputGraphSection = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} lg={4}>
          <Card style={{ borderRadius: 10, height: 300 }}>
            <CardContent >
              <Stack spacing={6}>
                <TextField
                  inputProps={{ style: { height: 30, width: '100%' } }}
                  disabled
                  id="outlined-disabled"
                  label="Annual Chipp Bamboo Demand (in MT)"
                  value={annualDemandCB || ''}
                />
                <TextField
                  inputProps={{ style: { height: 30 } }} sx={{ width: '100%' }}
                  disabled
                  id="outlined-disabled"
                  label="RB CB Ratio"
                  value={rbCbRatio || ''}
                />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Card style={{ borderRadius: 10 }}>
            <CardContent>
              <ReactApexChart
                options={requestLastWeek.options}
                series={requestLastWeek.series}
                type="bar"
                height={250}
                width="100%"
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={12}>
          <Card>
            <CardContent>
              <Typography variant='subtitle1' sx={{ marginBottom: 2 }}>Non Operating Days</Typography>
              {StateDistrictSection()}
              <Box
                sx={{
                  marginTop: 1,
                  height: '100%',
                  width: '100%',
                  '& .super-app-theme--cell': {
                    backgroundColor: 'rgba(224, 183, 60, 0.55)',
                    color: '#1a3e72',
                    fontWeight: '600',
                  },
                  '& .super-app.monsoonFactor100': {
                    backgroundColor: 'rgba(157, 255, 118, 0.49)',
                    color: '#1a3e72',
                    fontWeight: '600',
                  },
                  '& .super-app-theme--header': {
                    wordWrap: 'break-word',
                    wordBreak: 'break-all',
                    whiteSpace: 'initial'
                  },
                }}
              >
                <DataGrid
                  getRowHeight={() => 'auto'}
                  autoHeight
                  columns={previewHolidayColDef}
                  rows={holidayGridData}
                  getRowId={(row) => row?.month}
                  experimentalFeatures={{ newEditingApi: true }}
                  hideFooterPagination
                  hideFooterSelectedRowCount
                />
              </Box>
            </CardContent>
          </Card>

        </Grid>
      </Grid>
    )
  }

  const handleDatePickerChange = (value, type) => {
    if (type === 'Stakeholder') {
      setHitSelectedDates(value);
      let joinedValue = value.join(",")
      let array = joinedValue.split(',');
      const parsedValue = array?.map(item => (moment(item).format(API_DATE_FORMAT)))
      let apiData = {
        "date": parsedValue,
        "stakeHolderType": type,
        "financialYear": selectedFinancialYear,
        "state": stateValue,
        "district": districtValue
      }
      setHitSelectedDatesApi(apiData);
    }
    else if (type === 'Plant') {
      setPlantSelectedDates(value);
      let joinedValue = value.join(",")
      let array = joinedValue.split(',');
      const parsedValue = array.map(item => (moment(item).format(API_DATE_FORMAT)));
      let apiData = {
        "date": parsedValue,
        "stakeHolderType": type,
        "financialYear": selectedFinancialYear
      }
      setPlantSelectedDatesApi(apiData);
    }
  }

  const getSelectedValue = (dataToBePassed) => {
    setIsEditBtnDisabled(false);
    setSelectedFinancialYear(dataToBePassed);
    getAnnualDemandApi(dataToBePassed);
    getExpectedDeliveryShortfallApi(dataToBePassed);
    getDemandHolidayApi(dataToBePassed, stateValue, districtValue);
    getSuggestedRbCBRatioApi();
    getRbCbRatioApi(dataToBePassed);
    getAllStateApi();
  }

  const handleEditButtonChange = (e) => {
    e.preventDefault();
    if (editBtnTitle === 'Edit') {
      setShowYearlyInputFieldSection(true);
      setShowYearlyInputGraph(false);
      getExpectedDeliveryShortfallApi(selectedFinancialYear);
      setEditBtnTitle('Show')
    } else if (editBtnTitle === 'Show') {
      setShowYearlyInputFieldSection(false);
      setShowYearlyInputGraph(true);
      setEditBtnTitle('Edit');
      getAnnualDemandApi(selectedFinancialYear);
      getExpectedDeliveryShortfallApi(selectedFinancialYear);
      getDemandHolidayApi(selectedFinancialYear, stateValue, districtValue);
    }

  }

  const handleAnnualDemandCBChange = (e) => {
    e.preventDefault();
    const isValid = DEMAND_VALIDATIONS.annualCBValidation(e.target.value)
    isValid && setAnnualDemandCB(parseFloat(e.target.value))
  }

  const handleRbCbRatio = (e) => {
    const isValid = DEMAND_VALIDATIONS.rbcbRatioValidation(e.target.value)
    isValid && setRbCbRatio(parseFloat(e.target.value));
  }

  const onConfirmHoliday = () => {
    handlePlantHolidayDialogClose();
    handleStakeholderHolidayDialogClose();
    let dataValue = [hitSelectedDatesApi, plantSelectedDatesApi]
    let filterdata = dataValue.filter(item => item.length !== 0)
    saveHolidayApi(filterdata)
  }

  const handleHolidaySubmitChange = (e, type) => {
    type === "plant" ? handlePlantHolidayDialogOpen() : handleStakeholderHolidayDialogOpen();
  }

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow };
    return expectedDeliveryShortfallUpdatedData = updatedRow
  };

const onConfirmExpectedAvailabilityInRb = () => {
  handleExpectedAvailabilityInRbDialogClose();
  let data = { ...expectedDeliveryShortfallUpdatedData, financialYear: selectedFinancialYear }
  saveExpectedDeliveryShortfallApi(data);
}

  const handleSaveExpectedDeliveryBtn = (e) => {
    e.preventDefault();
    if (JSON.stringify(expectedDeliveryShortfallUpdatedData) === "{}") expectedDeliveryShortfallUpdatedData = rowData1[0]
    handleExpectedAvailabilityInRbDialogOpen();
  }

  const onStateChangeHandle = (e, value) => {
    e.preventDefault();
    setSaStateValue(e.target.textContent);
    getDemandHolidayApi(selectedFinancialYear, value.label, districtValue);
    getAllDistrictApi(e.target.textContent);
  }

  const onDistrictChangeHandle = (e, value) => {
    e.preventDefault();
    setDistrictValue(e.target.textContent);
    getDemandHolidayApi(selectedFinancialYear, stateValue, e.target.textContent);

  }




  // -----------------API Calls-------------------

  const onConfirmCbDemand = () => {
    handleCbDemandDialogClose();
    if (selectedFinancialYear && annualDemandCB && !(selectedFinancialYear === 'select')) {
      setFinancialYearError('');
      loaderService.showLoader();
      apiClient.post(ADD_ANNUALPLANT,
        {
          "financialYear": selectedFinancialYear,
          "annualDemand": annualDemandCB
        },
        {
          headers: {
            AuthKey: authKey,
          }
        })
        .then((response) => {
          toast.success(response.data.message)
          loaderService.hideLoader();

        }).catch(function (error) {
          loaderService.hideLoader();
          toast.error(error.message)
        });
    } else {
      setFinancialYearError('Please select financial year')
    }

  }

  const addAnnualDemandCBApi = () => {
    handleCbDemandDialogOpen();
  }

  const getAnnualDemandApi = (year) => {
    loaderService.showLoader();
    apiClient.post(GET_ANNUALDEMAND,
      {
        "financialYear": year
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let data = response.data.demandAnnual?.annualDemand ? response.data.demandAnnual?.annualDemand : ''
        setAnnualDemandCB(data);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getSuggestedRbCBRatioApi = () => {
    loaderService.showLoader();
    apiClient.post(GET_SUGGESTEDRBCBRATIO,
      {
        "financialYear": selectedFinancialYear
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setSuggestedRbCbRatio(response.data.demandRbcbratioMaster?.rbcbratio)
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const getRbCbRatioApi = (year) => {
    loaderService.showLoader();
    apiClient.post(GET_RBCBRATIO,
      {
        "financialYear": year
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let data = response.data.demandRbcbratioMaster?.rbcbratio ? response.data.demandRbcbratioMaster?.rbcbratio : ''
        setRbCbRatio(data)
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const onConfirmRbCbRatio = () => {
    handleRbCbRatioDialogClose();
    loaderService.showLoader();
    apiClient.post(SAVE_RBCBRATIO,
      {
        "financialYear": selectedFinancialYear,
        "rbcbratio": rbCbRatio
      },
      {
        headers: {
          AuthKey: authKey,
        }
      })
      .then((response) => {
        setSuggestedRbCbRatio(response.data.demandRbcbratioMaster?.rbcbratio);
        toast.success(response.data.message);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const saveRbCbRatio = () => {
    handleRbCbRatioDialogOpen();
  }

  const getExpectedDeliveryShortfallApi = (year) => {
    loaderService.showLoader();
    apiClient.post(GET_EXPECTED_DELIVERY_SHORTFALL,
      {
        "financialYear": year,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let apiData = response.data?.demandExpectedDeliveryShortfallLists ? response.data?.demandExpectedDeliveryShortfallLists : [];
        const rowData = JSON.parse(JSON.stringify(apiData));
        apiData?.map((i) => {
          if (i.month === 'Jan') i.month = 10
          else if (i.month === 'Feb') i.month = 11
          else if (i.month === 'Mar') i.month = 12
          else if (i.month === 'Apr') i.month = 1
          else if (i.month === 'May') i.month = 2
          else if (i.month === 'Jun') i.month = 3
          else if (i.month === 'Jul') i.month = 4
          else if (i.month === 'Aug') i.month = 5
          else if (i.month === 'Sep') i.month = 6
          else if (i.month === 'Oct') i.month = 7
          else if (i.month === 'Nov') i.month = 8
          else if (i.month === 'Dec') i.month = 9
        })
        const numAscending = [...apiData].sort((a, b) => a.month - b.month);
        let sorterdExpectedDeliveryShortfall = numAscending ? numAscending?.map((data) => data.expectedDeliveryShortfall) : []
        setShortFallChartData(sorterdExpectedDeliveryShortfall);

        let modifiedRowData = rowData?.reduce((result, data) => {
          result[data.month] = data.expectedDeliveryShortfall
          return result
        }, { 'id': 1 })

        if (!modifiedRowData || modifiedRowData?.length === 0) setRowData1([{
          'id': 1, 'Apr': 0, 'May': 0, 'Jun': 0, 'Jul': 0,
          'Aug': 0, 'Sep': 0, 'Oct': 0, 'Nov': 0, 'Dec': 0,
          'Jan': 0, 'Feb': 0, 'Mar': 0
        }])
        else setRowData1([modifiedRowData])
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const getDemandHolidayApi = (year, state, district) => {
    const templateData = [
      { id: 1, month: '01', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 2, month: '02', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [] },
      { id: 3, month: '03', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [] },
      { id: 4, month: '04', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 6, month: '05', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 7, month: '06', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 8, month: '07', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [] },
      { id: 9, month: '08', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 10, month: '09', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 11, month: '10', nonOperatingDaysHit: [,], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 12, month: '11', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
      { id: 5, month: '12', nonOperatingDaysHit: [], nonOperatingDaysLle: [], nonOperatingDaysTransporter: [], nonOperatingDaysPlant: [], },
    ]
    loaderService.showLoader();
    apiClient.post(GET_DEMAND_HOLIDAY,
      {
        "financialYear": year,
        "state": state,
        "district": district
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let arr = [];
        response.data.holidayMasterList?.map((item) => {
          if (item.stakeholderType === 'Stakeholder') {
            var hitData = Object.values((item.date).reduce((r, date) => {
              const [year, month, day] = date.substr(0, 10).split('-');
              const key = `${year}_${month}`;
              r[key] = r[key] || { month, nonOperatingDaysHit: [] };
              r[key].nonOperatingDaysHit.push(day);
              return r;
            }, {}));
            arr.push(...hitData)
            let modifiedDate = item.date.map((i) => {
              return moment(i).format(BASIC_DATE_FORMAT)
            })
            setHitSelectedDates(modifiedDate)
          }
          if (item.stakeholderType === 'Plant') {
            var plantData = Object.values((item.date).reduce((r, date) => {
              const [year, month, day] = date.substr(0, 10).split('-');
              const key = `${year}_${month}`;
              r[key] = r[key] || { month, nonOperatingDaysPlant: [] };
              r[key].nonOperatingDaysPlant.push(day);
              return r;
            }, {}));
            arr.push(...plantData);
            let modifiedDate = item.date.map((i) => {
              return moment(i).format(BASIC_DATE_FORMAT)
            })
            setPlantSelectedDates(modifiedDate)
          }
        })
        let mergeById = arr.map(itm => ({
          ...templateData.find((item) => (item.month === itm.month) && item),
          ...itm
        }));
        const result = mergeById.reduce((r, { month, nonOperatingDaysHit, nonOperatingDaysPlant, nonOperatingDaysLle, nonOperatingDaysTransporter }) => {
          if (r.get(month)) r.get(month).nonOperatingDaysHit.push(...nonOperatingDaysHit);
          if (r.get(month) && !nonOperatingDaysLle.includes(...nonOperatingDaysLle)) r.get(month).nonOperatingDaysLle.push(...nonOperatingDaysLle);
          if (r.get(month)) r.get(month).nonOperatingDaysTransporter.push(...nonOperatingDaysTransporter);
          if (r.get(month)) r.get(month).nonOperatingDaysPlant.push(...nonOperatingDaysPlant);

          else r.set(month, { month, nonOperatingDaysHit, nonOperatingDaysPlant, nonOperatingDaysLle, nonOperatingDaysTransporter });
          return r;
        }, new Map).values();

        setHolidayGridData([...result]);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const saveHolidayApi = (data) => {
    loaderService.showLoader();
    apiClient.post(SAVE_HOLIDAY,
      data,
      {
        headers: {
          AuthKey: authKey,
        }
      })
      .then((response) => {
        if (response.data?.isSuccess === true) toast.success(response.data.message);
        else toast.error(response.data?.message)
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const saveExpectedDeliveryShortfallApi = (data) => {
    loaderService.showLoader();
    apiClient.post(SAVE_EXPECTED_DELIVERY_SHORTFALL,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const onConfirmCalculateDashboard = () => {
    handleCalculateDashboardDialogClose();
    loaderService.showLoader();
    apiClient.post(CALCULATE_ANNUAL_DASHBOARD + `?userId=${uuid}`,
      {
        "financialYear": selectedFinancialYear,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const calculateAnnualDashboardApi = () => {
    handleCalculateDashboardDialogOpen();
  }

  const getAllStateApi = async () => {
    loaderService.showLoader();
    await apiClient.post(GET_All_STATE,
      null,
      {
        headers: {
          AuthKey: authKey,
        }
      })
      .then((response) => {
        let stateList = response.data?.stateList
        let mappedStates = stateList.map((item) => {
          return {
            'label': item
          }
        })
        setStateList(mappedStates);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  const getAllDistrictApi = (data) => {
    loaderService.showLoader();
    apiClient.post(GET_All_DISTRICT,
      {
        "state": data
      },
      {
        headers: {
          AuthKey: authKey,
        }
      })
      .then((response) => {
        let districtList = response.data?.districtLists
        let mappedDistrict = districtList?.map((item) => {
          return {
            'label': item
          }
        })
        setDistrictList(mappedDistrict);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message)
      });
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} lg={12}>
          {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM01</p>}
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                <Tab label="Yearly Input" value="1" />
                <Tab label="Annual Dashboard" value="2" />
              </TabList>
            </Box>

            <TabPanel value="1">
              <Grid container>
                <Grid item xs={12} lg={12}>
                  <Card style={{ marginBottom: 10 }}>
                    <CardContent>
                      <Grid container>
                        <Grid item xs={12} lg={2}>
                          <FinancialYearDropdown selectedYear={selectedFinancialYear} selectedValue={getSelectedValue} isDisabled={false} />
                        </Grid>
                        <Grid item xs={12} lg={10}>
                          <Stack direction="row" spacing={1} sx={{ float: 'right' }}>
                            <CustomButton
                              title={editBtnTitle}
                              disabled={isEditBtnDisabled}
                              startIcon={editBtnTitle == "Show" ? <ViewIcon /> : <EditIcon />}
                              onClick={(e) => handleEditButtonChange(e)} />
                            {showYearlyInputGraph &&
                              <CustomButton
                                disabled={isEditBtnDisabled}
                                startIcon={<CalculateIcon />}
                                title='Calculate Dashboard'
                                onClick={(e) => calculateAnnualDashboardApi(e)}
                              />
                            }
                          </Stack>
                        </Grid>

                      </Grid>

                    </CardContent>
                  </Card>
                  {showYearlyInputGraph && YearlyInputGraphSection()}
                  {showYearlyInputFieldSection &&
                    <Grid container>
                      <Grid item xs={12} lg={12}>
                        <Stack spacing={1}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} lg={6}>
                              <Card style={{ borderRadius: 10 }}>
                                <CardContent>
                                  <Stack spacing={1}>
                                    <TextField
                                      inputProps={{ style: { height: 30 } }} sx={{ width: '100%' }}
                                      id="outlined-basic" label="Annual Chip Bamboo Demand(in MT)"
                                      variant="outlined"
                                      type='number'
                                      onFocus={handleNumberFieldFocus}
                                      value={annualDemandCB || ''}
                                      helperText={financialYearError}
                                      onChange={(e) => handleAnnualDemandCBChange(e)} />

                                    <Button sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                                      size="medium"
                                      variant="contained"
                                      disabled={!annualDemandCB}
                                      endIcon={<SubmitIcon />}
                                      onClick={() => addAnnualDemandCBApi()}>Submit</Button>
                                  </Stack>
                                </CardContent>
                              </Card>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Card style={{ borderRadius: 10 }}>
                                <CardContent>
                                  <Stack spacing={1.5}>
                                    <TextField inputProps={{ style: { height: 30 } }} sx={{ width: '100%' }}
                                      id="outlined-basic" disabled label="Suggested RB-CB Ratio"
                                      variant="outlined" value={suggestedRbCbRatio || ''} />
                                    <TextField inputProps={{ style: { height: 30 } }} sx={{ width: '100%' }}
                                      id="outlined-basic"
                                      label="RB-CB Ratio"
                                      variant="outlined"
                                      value={rbCbRatio}
                                      type="number"
                                      onFocus={handleNumberFieldFocus}
                                      onChange={(e) => handleRbCbRatio(e)} />

                                    <Button endIcon={<SubmitIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }} disabled={!rbCbRatio}
                                      variant="contained" onClick={() => saveRbCbRatio()}>Submit</Button>
                                  </Stack>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                          <Grid container>
                            <Grid item xs={12} lg={12}>
                              <Card style={{ borderRadius: 10 }}>
                                <CardContent>
                                  <Stack spacing={1}>
                                    <Typography variant='subtitle1'>Expected Bamboo Availability (in MT)</Typography>
                                    <div style={{ height: 'auto', width: '100%' }}>
                                     
                                        <DataGrid
                                          autoHeight
                                          hideFooter
                                          columns={columnDefs}
                                          rows={rowData1}
                                          processRowUpdate={(e) => processRowUpdate(e)}
                                          experimentalFeatures={{ newEditingApi: true }}
                                          hideFooterPagination
                                          hideFooterSelectedRowCount
                                        />
                                      
                                    </div>
                                    {/* <Button endIcon={<SubmitIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                                      variant="contained"
                                      onClick={(e) => handleSaveExpectedDeliveryBtn(e)}>Submit</Button> */}
                                  </Stack>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                          <Grid container>
                            <Grid item xs={12} lg={12}>
                              <Stack direction='row' spacing={1}>
                                <Grid item xs={12} lg={4}>
                                  <Card style={{ borderRadius: 10 }}>
                                    <CardContent>
                                      <Stack spacing={1}>
                                        <Typography variant='subtitle1'>Holiday</Typography>
                                        <Typography variant='subtitle2'>Plant</Typography>
                                        <DatePicker
                                          value={plantSelectedDates}
                                          onChange={(e) => handleDatePickerChange(e, 'Plant')}
                                          plugins={[
                                            <DatePanel style={{ position: 'inherit' }} />
                                          ]}
                                          style={{ width: '100%', height: 50 }}
                                          multiple
                                        />
                                        <Button endIcon={<SubmitIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }} variant="contained" onClick={(e) => handleHolidaySubmitChange(e, "plant")}>Submit</Button>
                                      </Stack>
                                    </CardContent>
                                  </Card>
                                </Grid>
                                <Grid item xs={12} lg={8}>
                                  <Card style={{ borderRadius: 10 }}>
                                    <CardContent>
                                      <Stack spacing={1}>
                                        {StateDistrictSection()}
                                        <Typography variant='subtitle2'>Stakeholder</Typography>
                                        <DatePicker
                                          value={hitSelectedDates}
                                          onChange={(e) => handleDatePickerChange(e, 'Stakeholder')}
                                          plugins={[
                                            <DatePanel style={{ position: 'inherit' }} />
                                          ]}
                                          style={{ width: '100%', height: 50 }}
                                          multiple
                                        />
                                        {/* <Grid item xs={12} lg={4}>
                                          <Typography variant='subtitle2'>LLE</Typography>
                                          <DatePicker
                                            value={lleSelectedDates}
                                            onChange={(e) => handleDatePickerChange(e, 'LLE')}
                                            plugins={[
                                              <DatePanel style={{ position: 'inherit' }} />
                                            ]}
                                            style={{ width: '100%', height: 50 }}
                                            multiple
                                          />
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                          <Typography variant='subtitle2'>Transporter</Typography>
                                          <DatePicker
                                            value={transporterSelectedDates}
                                            onChange={(e) => handleDatePickerChange(e, 'TR')}
                                            plugins={[
                                              <DatePanel style={{ position: 'inherit' }} />
                                            ]}
                                            style={{ width: '100%', height: 50 }}
                                            multiple
                                          />
                                        </Grid> */}
                                        {/* </Grid> */}
                                        <Button endIcon={<SubmitIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }} variant="contained" onClick={(e) => handleHolidaySubmitChange(e, "stakeholder")}>Submit</Button>
                                      </Stack>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              </Stack>
                            </Grid>
                          </Grid>
                        </Stack>
                      </Grid>
                    </Grid>
                  }
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value="2"><YearlyDashboard /></TabPanel>

          </TabContext>
        </Grid>
      </Grid>
      <ConfirmationPopover onOpen={cbDemandDialog} onConfirm={onConfirmCbDemand} onClose={handleCbDemandDialogClose} action="Annual Demand CB" actionText="submit annual demand cb" />
      <ConfirmationPopover onOpen={rbCbRatioDialog} onConfirm={onConfirmRbCbRatio} onClose={handleRbCbRatioDialogClose} action="RB-CB Ratio" actionText="submit RB-CB ratio" />
      <ConfirmationPopover onOpen={expectedAvailabilityInRbDialog} onConfirm={onConfirmExpectedAvailabilityInRb} onClose={handleExpectedAvailabilityInRbDialogClose} action="Expected Availablity(in RB)" actionText="submit expected availability(in RB)" />
      <ConfirmationPopover onOpen={plantHolidayDialog} onConfirm={onConfirmHoliday} onClose={handlePlantHolidayDialogClose} action="Plant Holiday" actionText="submit plant holiday" />
      <ConfirmationPopover onOpen={stakeholderHolidayDialog} onConfirm={onConfirmHoliday} onClose={handleStakeholderHolidayDialogClose} action="Stakeholder Holiday" actionText="submit stakeholder holiday" />
      <ConfirmationPopover onOpen={calculateDashboardDialog} onConfirm={onConfirmCalculateDashboard} onClose={handleCalculateDashboardDialogClose} action="Calculate Dashbaord" />
      </>
  )
}

export default YearlyInput